import React, { Fragment, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import VisitHistoryModalButton from '../../../../components/common/Button/VisitHistoryModalButton'
import MobiScrollCalender from '../../../../components/common/MobiScrollCalendar/MobiScrollCalendar'
import { dateDbFormat, dateUSFormat, twelveHourTimeWithZone } from '../../../../utils/dateTimeUtils'
import { toast } from 'react-toastify'
import { CCollapse, CCol, CRow } from '@coreui/react-pro'
import { isWithinInterval, subDays } from 'date-fns'
import { getPCCNoteDetails, getPCCNotes } from '../../../../helper/pccApiHelper'

function filterPCCNotesByDate(notesInfoData = [], notesStartDate) {
  let noteFilterDate = new Date(notesStartDate)
  const interval = {
    start: subDays(noteFilterDate, 30),
    end: subDays(noteFilterDate, -1),
  }

  return notesInfoData?.filter(({ effectiveDate }) => {
    return effectiveDate && isWithinInterval(new Date(effectiveDate), interval)
  })
}

export default function PCCFacilityNoteDisplay({ patientDetails }) {
  const thisDate = useSelector((state) => state?.census?.activeDate)
  const [notesStartDate, setNotesStartDate] = useState(
    dateUSFormat(thisDate || new Date().toISOString()),
  )

  const [facilityNurusNotesVisible, setFacilityNurusNotesVisible] = useState(false)
  const [copyPccNoteText, setCopyPccNoteText] = useState(null)
  const [notesDt, setNoteDt] = useState({})
  const [notesInfoData, setNotesInfoData] = useState([])
  const [selectedNote, setSelectedNote] = useState(null)

  useEffect(() => {
    const notesData = async () => {
      if (patientDetails?.patient_id) {
        try {
          await getPCCNotes(patientDetails?.patient_id, dateDbFormat(notesStartDate)).then(
            (res) => {
              setNotesInfoData(res.status !== 'failure' ? res : [])
            },
          )
        } catch (e) {
          console.error(e)
        }
      }
    }
    notesData()
  }, [patientDetails?.patient_id, notesStartDate])

  const getNoteDetails = async (note_id) => {
    await getPCCNoteDetails(patientDetails?.patient_id, note_id).then((res) => {
      if (res?.orgId) {
        setNoteDt(res)
        setCopyPccNoteText(res.sections[0]?.value)
      }
    })
  }

  return (
    <>
      <CRow>
        <CCol xs={8}>
          <h5 className="mt-3">Effective Date</h5>
        </CCol>
        {facilityNurusNotesVisible && copyPccNoteText && (
          <CCol xs={4}>
            <VisitHistoryModalButton
              onClick={() => {
                navigator.clipboard.writeText(copyPccNoteText)
                toast.success('Note Copied!')
              }}
              type={'copyText'}
            />
          </CCol>
        )}
      </CRow>
      <CRow>
        <div className="labs-and-radio-subtitle">
          <MobiScrollCalender
            type={'PCC'}
            value={notesStartDate}
            handleDateChange={(date) => setNotesStartDate(date)}
          ></MobiScrollCalender>
        </div>
        <p className="labs-and-radio-description">
          Note : We will show notes up to 30 days before selected date
        </p>
      </CRow>
      <CRow>
        <h6>Facility Notes</h6>
      </CRow>
      {notesInfoData?.length === 0 && <p className="notes-description">No results found...</p>}
      {filterPCCNotesByDate(notesInfoData, notesStartDate)?.map((info, index) => (
        <div key={index}>
          <CRow>
            <CCol xs={6}>
              <p className="notes-description">
                {info?.progressNoteType} - by {info?.createdBy}
              </p>
            </CCol>
            <CCol xs={4}>
              <p className="notes-description">
                {info?.effectiveDate ? twelveHourTimeWithZone(info?.effectiveDate) : '-'}
              </p>
            </CCol>
            <CCol xs={2}>
              <span className="notes-description">
                {facilityNurusNotesVisible && selectedNote == index && (
                  <i
                    className="fa-sharp fa-solid fa-chevron-up icon align-items-end"
                    style={{ fontSize: '0.8em', margin: '0 0.5rem 0.5rem' }}
                    onClick={() => {
                      setFacilityNurusNotesVisible(!facilityNurusNotesVisible)
                    }}
                  ></i>
                )}
                {(selectedNote != index || !facilityNurusNotesVisible) && (
                  <i
                    className="fa-sharp fa-solid fa-chevron-down icon align-items-end"
                    style={{ fontSize: '0.8em', margin: '0 0.5rem 0.5rem' }}
                    onClick={() => {
                      setFacilityNurusNotesVisible(!facilityNurusNotesVisible)
                      setSelectedNote(index)
                      getNoteDetails(info?.progressNoteId)
                    }}
                  ></i>
                )}
              </span>
            </CCol>
          </CRow>
          <CCollapse visible={facilityNurusNotesVisible && selectedNote == index}>
            <div>
              <p>
                Patient Name:{' '}
                {patientDetails.patient_lastname + ' ' + patientDetails.patient_firstname}
              </p>
              <p>
                DOB: {patientDetails.patient_dob ? dateUSFormat(patientDetails.patient_dob) : '-'}
              </p>
              <p>
                Effective Date:{' '}
                {notesDt?.effectiveDate ? twelveHourTimeWithZone(notesDt?.effectiveDate) : '-'}
              </p>
              <p>Note Type: {notesDt.progressNoteType}</p>
              <p>
                Created by:{' '}
                {notesDt?.createdDate ? twelveHourTimeWithZone(notesDt?.createdDate) : '-'}
              </p>
              <p>{(notesDt?.sections && notesDt?.sections[0]?.name) || ''}</p>
              <p>{(notesDt?.sections && notesDt?.sections[0]?.value) || ''}</p>
            </div>
          </CCollapse>
        </div>
      ))}
    </>
  )
}
